import React from 'react';
import DOMPurify from 'dompurify';
import styles from './styles/Q4EOffers.module.scss';
import { getProviderImgUrl } from './utils';

const Q4EOffers = ({ policyProviders, offers }) => {
  return (
    <div className={styles.offers}>
      {offers.map(({ title, policyProviderId, description, logoUrl }, idx) => {
        const provider = policyProviders.find(R.propEq('id', policyProviderId));
        return (
          <div key={`${policyProviderId}_${idx}`} className={styles.offer}>
            <div className={styles.top}>
              <img
                alt={provider.name}
                src={logoUrl || getProviderImgUrl(provider.name)}
              />
              <div className={styles.title}>{title}</div>
            </div>
            <div
              className={styles.desc}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(description, {
                  ADD_ATTR: ['target', 'rel'],
                }),
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Q4EOffers;
